import { createContext, useState, useEffect } from 'react';

// Creamos el contexto de autenticación
export const AuthContext = createContext();

// Proveedor de autenticación
/* eslint-disable react/prop-types */
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); 

  // Verificar si existe un token en localStorage al cargar
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
      setUser(JSON.parse(localStorage.getItem('user')));
    }
    setLoading(false)
  }, []);

  // Función de inicio de sesión
  const login = (token, user) => {
    setIsAuthenticated(true);
    setUser(user);
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(user));
  };

  // Función de cierre de sesión
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  const updateUserData = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  // Proveedor del contexto, pasando los valores y funciones
  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading, updateUserData }}>
      {children}
    </AuthContext.Provider>
  );
};


export default AuthProvider;
